/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {HttpClientTestingBackend as ɵangular_packages_common_http_testing_testing_a} from './src/backend';